import { FC, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { UsedEncounterSchema } from '@/shared/api/transcriptor/transcriptorApi';
import { Input, Select } from '@/shared/ui';

import styles from '../../Encounters.module.scss';

type EncountersFiltersProps = {
  searchQuery: string;
  selectedSchemaCode: string | null;
  usedSchemas: UsedEncounterSchema[];
  onSearchQueryChange: (value: string) => void;
  onSchemaCodeChange: (value: string | null) => void;
};

const ALL_TYPES_VALUE = '__all__';

export const EncountersFilters: FC<EncountersFiltersProps> = (props) => {
  const {
    searchQuery,
    selectedSchemaCode,
    usedSchemas,
    onSearchQueryChange,
    onSchemaCodeChange,
  } = props;
  const { formatMessage } = useIntl();

  const typeOptions = useMemo(
    () => [
      {
        value: ALL_TYPES_VALUE,
        label: (
          <FormattedMessage
            id="encounters.filters.allTypes"
            defaultMessage="All types"
          />
        ),
      },
      ...usedSchemas.map((schema) => ({
        value: schema.schema_code,
        label: `${schema.schema_name ?? schema.schema_code} (${schema.count})`,
      })),
    ],
    [usedSchemas],
  );

  return (
    <div className={styles.filters} data-section="encounters-filters">
      <Input
        name="encounters-search"
        className={styles.searchInput}
        value={searchQuery}
        icon="search"
        inputMode="search"
        placeholder={formatMessage({
          id: 'encounters.searchPlaceholder',
          defaultMessage: 'Search encounters…',
        })}
        onChange={(event) => onSearchQueryChange(event.target.value)}
      />
      <Select
        name="encounters-type"
        className={styles.typeSelect}
        options={typeOptions}
        value={selectedSchemaCode ?? ALL_TYPES_VALUE}
        isSearchable={false}
        onChange={(nextValue) => {
          const code = typeof nextValue === 'string' ? nextValue : null;
          onSchemaCodeChange(code && code !== ALL_TYPES_VALUE ? code : null);
        }}
      />
    </div>
  );
};
